/**
 * Atomic TextField component
 * Self-contained, no external dependencies
 */
import React from 'react';
import './TextField.css';

export const TextField = ({ 
  label, 
  value, 
  onChange, 
  placeholder, 
  multiline = false,
  rows = 3,
  disabled = false,
  required = false,
  type = 'text',
  helperText = null,
  error = false
}) => {
  const Component = multiline ? 'textarea' : 'input';
  
  return (
    <div className={`gwe-textfield ${error ? 'gwe-textfield--error' : ''}`}>
      {label && (
        <label className="gwe-textfield__label">
          {label}
          {required && <span className="gwe-textfield__required">*</span>}
        </label>
      )}
      <Component
        className="gwe-textfield__input"
        type={multiline ? undefined : type}
        rows={multiline ? rows : undefined}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
      />
      {helperText && (
        <span className="gwe-textfield__helper">{helperText}</span>
      )}
    </div>
  );
};
